import {InternSet} from "internmap";

export default function intersection(values, ...others) {
  values = new InternSet(values);
  others = others.map(set);
  out: for (const value of values) {
    for (const other of others) {
      if (!other.has(value)) {
        values.delete(value);
        continue out;
      }
    }
  }
  return values;
}

function set(values) {
  return values instanceof InternSet ? values : new InternSet(values);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-contour/node_modules/d3-array/src/intersection.js
// module id = 4611
// module chunks = 0